import * as constants from './constants';
import { guardNullOrUndefined } from '../utils/guards';

export const fetchSuggestionsRequest = () => ({
  type: constants.FETCH_SUGGESTIONS_REQUEST,
});

export const fetchSuggestionsStart = () => ({ type: constants.FETCH_SUGGESTIONS_START });

export const fetchSuggestionsSuccess = data => {
  guardNullOrUndefined(data);
  return { type: constants.FETCH_SUGGESTIONS_SUCCESS, data };
};

export const fetchSuggestionsFailed = error => {
  guardNullOrUndefined(error);
  return { type: constants.FETCH_SUGGESTIONS_FAILED, error };
};



// WEBPACK FOOTER //
// ./app/Suggestions/actions.js